export default __webpack_public_path__ + "static/media/banner1.965cc387.svg";